<template>
  <template v-if="labels.length">
    <span
      v-for="(label, index) in labels"
      :key="index"
      class="label label--marketing"
      v-text="label"
    />
  </template>
</template>

<script setup lang="ts">
import type { EsProduct } from '~/types/elastic'

const props = defineProps<{ product: EsProduct }>()

const labels = computed<string[]>(() =>
  (props.product?.marketingLabel?.label || '').split(', ').filter((label: string) => label !== ''),
)
</script>

<style src="~layers/app/components/Product/Labels.css" />
